import React from "react";

export const UsbDetection = ({ viewBox = "0 0 20 20" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      fill="currentColor"
    >
      <path d="M13.3333 1.66669C13.7537 1.66655 14.1587 1.82536 14.467 2.11127C14.7754 2.39718 14.9642 2.78906 14.9958 3.20835L14.9999 3.33335V6.66669H15.8333C16.0374 6.66671 16.2344 6.74165 16.3869 6.87728C16.5394 7.01292 16.6369 7.19981 16.6608 7.40252L16.6666 7.50002V13.3334C16.6665 14.4071 16.252 15.4393 15.5094 16.2148C14.7668 16.9903 13.7535 17.4493 12.6808 17.4959L12.4999 17.5H7.49992C6.4262 17.5 5.39395 17.0854 4.61844 16.3428C3.84292 15.6002 3.38402 14.5869 3.33742 13.5142L3.33325 13.3334V7.50002C3.33328 7.29591 3.40822 7.09891 3.54385 6.94638C3.67948 6.79385 3.86638 6.6964 4.06909 6.67252L4.16659 6.66669H4.99992V3.33335C4.99979 2.91287 5.15859 2.50788 5.4445 2.19956C5.73041 1.89125 6.12229 1.70239 6.54159 1.67085L6.66659 1.66669H13.3333ZM13.3333 3.33335H6.66659V6.66669H13.3333V3.33335ZM9.16659 4.16669V5.83335H7.49992V4.16669H9.16659ZM12.4999 4.16669V5.83335H10.8333V4.16669H12.4999Z" />
    </svg>
  );
};
